"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VestingDeployButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const icons_material_1 = require("@mui/icons-material");
const viem_1 = require("viem");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const provider_user_1 = require("@dzambalaorg/provider-user");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const deployVesting_json_1 = __importDefault(require("@framework/abis/json/VestingFactoryFacet/deployVesting.json"));
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const dialog_1 = require("./dialog");
const VESTING_CONTRACT_DEPLOY_DIALOG_KEY = "vestingContractDeploy";
const VestingDeployButton = (props) => {
    const { className, disabled, variant = styled_1.ListActionVariant.button } = props;
    const { profile } = (0, provider_user_1.useUser)();
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { openFormDialog, formDialogUniqueKey, mode } = (0, react_hooks_1.useDialogForm)();
    const handleDeploy = () => {
        openFormDialog(VESTING_CONTRACT_DEPLOY_DIALOG_KEY, void 0, "button");
    };
    const encodedExternalId = BigInt((0, viem_1.concatHex)([(0, viem_1.padHex)((0, viem_1.toHex)(String(profile.id)), { size: 3 }), (0, viem_1.padHex)((0, viem_1.toHex)("0"), { size: 4 })]));
    const { handleDeployConfirm } = (0, react_hooks_eth_1.useDeploy)(async (values, sign, systemContract) => {
        const { owner, startTimestamp, cliffInMonth, monthlyRelease, contractTemplate } = values;
        const nonce = sign.nonce;
        return writeContractAsync({
            address: systemContract.address,
            abi: deployVesting_json_1.default,
            functionName: "deployVesting",
            args: [
                {
                    nonce,
                    bytecode: sign.bytecode,
                    externalId: encodedExternalId,
                },
                {
                    owner,
                    startTimestamp: BigInt(Math.ceil(new Date(startTimestamp).getTime() / 1000)), // in seconds,
                    cliffInMonth,
                    monthlyRelease: BigInt(monthlyRelease),
                    contractTemplate: Object.values(types_1.VestingContractTemplates).indexOf(contractTemplate).toString(),
                },
                [],
                sign.signature,
            ],
        });
    });
    const onDeployConfirm = ({ data, form }) => {
        return handleDeployConfirm({
            url: "/contract-manager/vesting",
            method: "POST",
            data: Object.assign(data, { externalId: encodedExternalId.toString() }),
        }, form);
    };
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleDeploy, icon: icons_material_1.Add, message: "form.buttons.deploy", className: className, dataTestId: "VestingDeployButton", disabled: disabled, variant: variant }), (0, jsx_runtime_1.jsx)(dialog_1.VestingDeployDialog, { onExternalConfirm: onDeployConfirm, open: formDialogUniqueKey === `${VESTING_CONTRACT_DEPLOY_DIALOG_KEY}.${mode}`, initialValues: {
                    owner: "",
                    startTimestamp: new Date().toISOString(),
                    cliffInMonth: 12,
                    monthlyRelease: 1000,
                    contractTemplate: types_1.VestingContractTemplates.VESTING,
                } })] }));
};
exports.VestingDeployButton = VestingDeployButton;
//# sourceMappingURL=index.js.map